import script from "./CardText.vue?vue&type=script&lang=ts&setup=true"
export * from "./CardText.vue?vue&type=script&lang=ts&setup=true"

import "./CardText.vue?vue&type=style&index=0&id=17d09e84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17d09e84"]])

export default __exports__